import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import { Edit } from 'styled-icons/fa-regular/Edit'
import { TrashAlt } from 'styled-icons/fa-regular/TrashAlt'

TimeAgo.locale(en)
const ago = new TimeAgo('en-US')

const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
`
const Title = styled.div`
  flex: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const Icon = styled.span`
  flex: 0;
  margin-left: 0.8rem;
  color: dodgerblue;
`
const Attribute = styled.div`
  display: flex;
  flex-flow: row nowrap;
  font-size: 1.1rem;
`

class NoticeItem extends React.Component {

  onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.onItemClick(this.props.notice, 'view')
  }
  onEdit = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.onItemClick(this.props.notice, 'edit')
  }

  onDelete = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.onItemClick(this.props.notice, 'remove')
  }

  render() {
    const { notice, editable } = this.props
    const { created, author, title } = notice

    return (
      <button type='button' className='list-group-item' onClick={this.onClick}>
        <Header>
          <Title>{title}</Title>
          { editable && <Icon><TrashAlt size={14} onClick={this.onDelete}/></Icon> }
          { editable && <Icon><Edit size={14} onClick={this.onEdit}/></Icon> }
        </Header>
        <Attribute>
          <div style={{ marginRight: '20px' }}>{ago.format(new Date(created))}</div>
          <div>{author}</div>
        </Attribute>
      </button>
    )
  }
}

NoticeItem.defaultProps = {
  notice: {},
  editable: false,
  onItemClick: () => {},
}

NoticeItem.propTypes = {
  notice: PropTypes.object,
  editable: PropTypes.bool,
  onItemClick: PropTypes.func,
}

export default NoticeItem



// WEBPACK FOOTER //
// ./src/components/widgets/NoticeItem.js